import { Controller } from "@hotwired/stimulus"
import { formatDate, getJSON, listResults } from "../api.js"

// Historia logowań: własne zdarzenia + nieudane próby na mój e-mail (personel: całość).
export default class extends Controller {
  static targets = ["rows", "status", "pagination", "pageInfo", "prevLink", "nextLink"]
  static values = { url: String } // /api/auth-events/

  static EVENT_BADGE = {
    login:        ["sent", "logowanie"],
    logout:       ["new",  "wylogowanie"],
    login_failed: ["hot",  "nieudana próba"],
  }

  connect() { this.load() }

  async load() {
    // Paginacja server-side: strona z URL strony (`?page=`), fetch tej samej strony z API.
    const page = Number(new URLSearchParams(window.location.search).get("page")) || 1
    const url = page > 1 ? `${this.urlValue}?page=${page}` : this.urlValue
    let data
    try {
      data = await getJSON(url)
    } catch {
      this.#status("Nie udało się załadować historii. Odśwież stronę.")
      return
    }
    const events = listResults(data)
    this.rowsTarget.textContent = ""
    if (!events.length) {
      this.#status("Brak zdarzeń.")
      this.#renderPagination(data, page)
      return
    }
    this.#status(null)
    const template = document.getElementById("auth-log-row-template")
    for (const event of events) {
      const row = template.content.firstElementChild.cloneNode(true)
      const [kind, label] = this.constructor.EVENT_BADGE[event.event_type] ?? ["new", event.event_type]
      const badge = row.querySelector('[data-field="badge"]')
      badge.className = `ls-badge ls-badge--${kind}`
      badge.textContent = label
      row.querySelector('[data-field="email"]').textContent = event.email || "—"
      row.querySelector('[data-field="ip"]').textContent = event.ip_address || "—"
      row.querySelector('[data-field="ua"]').textContent = event.user_agent || "—"
      row.querySelector('[data-field="created"]').textContent = formatDate(event.created)
      this.rowsTarget.appendChild(row)
    }
    this.#renderPagination(data, page)
  }

  #renderPagination(data, page) {
    if (!this.hasPaginationTarget) return
    const hasPrev = page > 1
    const hasNext = Boolean(data.next)
    this.paginationTarget.hidden = !hasPrev && !hasNext
    if (this.hasPrevLinkTarget) {
      this.prevLinkTarget.hidden = !hasPrev
      if (hasPrev) this.prevLinkTarget.setAttribute("href", `?page=${page - 1}`)
    }
    if (this.hasNextLinkTarget) {
      this.nextLinkTarget.hidden = !hasNext
      if (hasNext) this.nextLinkTarget.setAttribute("href", `?page=${page + 1}`)
    }
    if (this.hasPageInfoTarget) this.pageInfoTarget.textContent = `Strona ${page}`
  }

  #status(message) {
    if (!this.hasStatusTarget) return
    this.statusTarget.hidden = message === null
    if (message !== null) this.statusTarget.textContent = message
  }
}
